import { EmbeddedPodlet } from "@mobility-item-page/client";
import { useAdViewAd } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import { usePodlets } from "../podlets.ts";

export const Recommendations = () => {
  const { pro_features } = useAdViewAd();
  const { recommendationsVariant } = useAppConfig();
  const { recommendations } = usePodlets();

  if (recommendationsVariant === "NoRecommendations" || pro_features?.recommendationsVariant === "NoRecommendations") {
    return null;
  }

  return (
    <EmbeddedPodlet
      response={recommendations}
      cautiouslyReloadScriptOnHydrationError={true}
      suppressHydrationWarning={true}
    />
  );
};
